import { render, staticRenderFns } from "./ShareReportLinkModal.vue?vue&type=template&id=2b231b02"
import script from "./ShareReportLinkModal.vue?vue&type=script&lang=js"
export * from "./ShareReportLinkModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports